import "@lodestone/hungry-lion-procurement-ui/tokens.css";
import { TooltipProvider } from "@lodestone/hungry-lion-procurement-ui/components/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import { createRoot } from "react-dom/client";

import { createProcurementRouter } from "./app-router";
import { AuthSessionProvider } from "./auth/logto-auth-session";
import { ProductionProcurementRuntimeProvider } from "./runtime/production-runtime";
import "./styles.css";

const queryClient = new QueryClient();
const router = createProcurementRouter({ queryClient });

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthSessionProvider>
      <ProductionProcurementRuntimeProvider>
        <TooltipProvider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </TooltipProvider>
      </ProductionProcurementRuntimeProvider>
    </AuthSessionProvider>
  </React.StrictMode>,
);
